/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="17.5" cy="17.5" r="6" />
      <path d="M17.5,21 C17.223,21 17,21.225 17,21.5 C17,21.775 17.223,22 17.5,22 C17.775,22 18,21.776 18,21.501 C18,21.226 17.775,21 17.5,21 Z" />
      <path d="M15.75,15.75 C15.75,14.783 16.533,14 17.5,14 C18.467,14 19.25,14.783 19.25,15.75 C19.25,16.717 18.467,17.5 17.5,17.5 L17.5,19.5" />
      <path d="M18.5,4.5 L18.5,2.5 L5.5,2.5 L5.5,0.5 L0.5,0.5 L0.5,16 C0.5,16.829 1.17,17.5 2,17.5 C2.828,17.5 3.5,16.829 3.5,16 L3.5,4.5 L20.5,4.5 L20.5,10" />
      <path d="M2,17.5 L9.5,17.5" />
    </g>
  </svg>
);

export default Icon;
